import axios from "axios";

export default async function getLayerId(serviceName, tableOrLayerName, token) {
  try {
    // const url = `${
    //   process.env.REACT_APP_SERVICE_ENDPOINT
    // }/${serviceName}/MapServer?f=pjson${token ? `&token=${token}` : ""}`;
    // console.log(url);
    const results = await axios.get(
      `${
        process.env.REACT_APP_SERVICE_ENDPOINT
      }/${serviceName}/MapServer?f=pjson${token ? `&token=${token}` : ""}`
    );
    let id;
    const checkTable = results?.data?.tables?.find(
      (item) => item.name === tableOrLayerName
    );
    if (checkTable !== undefined) {
      id = checkTable.id;
    } else {
      const checkLayers = results?.data?.layers?.find(
        (item) => item.name === tableOrLayerName
      );
      if (checkLayers !== undefined) {
        id = checkLayers.id;
      } else {
        id = "-1";
      }
    }
    return id;
  } catch (error) {
    console.log(error);
    return "";
  }
}
